module.exports = __webpack_public_path__ + "static/img/bulk-order.3aa70c5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/bulk-order.png
// module id = 0A8A
// module chunks = 1